<template>
  <div class="alert-container">
    <div class="modal-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'AlertModal'
  }
</script>
<style>
  
.alert-container{
  width: 100vw; 
  height: 100vh; 
  position: fixed;
  z-index: 5000; 
  overflow: hidden; 
  padding: 1.5rem;
  top: 0; 
  right: 0rem; 
  display: flex; 
  justify-content: end; 
  align-items: baseline;
}

.modal-content .filter-item {
  margin: 1rem 0rem;
}

.modal-content>h1{
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
}

.modal-content>h1>i{
  cursor: pointer;
}

.modal-content>input{
  margin-bottom: 1.5rem;
}

.modal-content>span:first-of-type{
  color: #717182;
  margin-bottom: 1rem;
}

.modal-content>span:last-of-type{
  color: #000;
  font-weight: bold;
}
</style>